import {
  SearchOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Form, Input, Tooltip, Typography } from 'antd';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  FILTER_TYPE_MENU,
  PF,
} from '@pages/Clients/NewClientsList/data/constants';
import { Segments } from '@pages/Clients/NewClientsList/ui';
import { ClientVisit } from '@pages/Clients/NewClientsList/ui/ClientVisit';
import { FilterTypeComponent } from '@pages/Clients/NewClientsList/ui/FilterTypeComponent';
import { VisitFilter } from '@pages/Clients/NewClientsList/ui/VisitFilter';

import type { FC } from 'react';

const { Title } = Typography;

export const Filters: FC = () => {
  const {
    filters,
    searchValue,
    addNewFilters,
    deleteFilterById,
    onChangeSearchValue,
    onSearch,
    onResetFilters,
    onResetClientsFilter,
    onResetVisitsFilter,
  } = useNewClientsListContext();

  const isTooShort = searchValue.length > 0 && searchValue.length < 3;

  return (
    <div className={`${PF}__filters`}>
      <Form.Item
        validateStatus={isTooShort ? 'error' : ''}
        help={isTooShort ? 'Минимум 3 символа' : null}
      >
        <Input
          addonBefore={<SearchOutlined />}
          value={searchValue}
          onChange={onChangeSearchValue}
          onPressEnter={() => {
            if (!isTooShort) onSearch();
          }}
          placeholder="Поиск по имени, никнейму в соц. сетях, ID, телефону, email, дополнительным полям"
        />
      </Form.Item>

      <Segments />

      <div className={`${PF}__row`}>
        <Title level={5} className={`${PF}__row__title`}>
          Фильтры:
        </Title>
        <div className={`${PF}__filters-list`}>
          {filters.map((filter, index) => {
            const isLastItem = index === filters.length - 1;
            const nextFilter = filters[index + 1];
            const isNextFilterDifferentType = !!nextFilter;
            const isOnlyOneFilter = filters.length === 1;
            return (
              <div key={filter.id} className={`${PF}__filters-list__item`}>
                <VisitFilter id={filter.id} onClear={onResetVisitsFilter} />
                <ClientVisit id={filter.id} onClear={onResetClientsFilter} />

                <FilterTypeComponent
                  type={nextFilter?.type}
                  hide={!isNextFilterDifferentType}
                />

                {!isOnlyOneFilter && (
                  <Tooltip
                    title="Удалить группу"
                    placement="top"
                    color="white"
                    classNames={{
                      body: `${PF}__row__tooltip`,
                    }}
                  >
                    <Button
                      danger
                      type="default"
                      icon={<DeleteOutlined />}
                      className={`${PF}__filters-list__item__button`}
                      onClick={() => deleteFilterById(filter.id)}
                    />
                  </Tooltip>
                )}

                {isLastItem && (
                  <Dropdown
                    menu={{
                      items: FILTER_TYPE_MENU,
                      onClick: ({ key }) => {
                        if (key === 'and' || key === 'or') {
                          addNewFilters(key);
                        }
                      },
                    }}
                    trigger={['click']}
                  >
                    <Tooltip
                      title="Добавить группу"
                      placement="top"
                      color="white"
                      classNames={{
                        body: `${PF}__row__tooltip`,
                      }}
                    >
                      <Button
                        block
                        type="default"
                        icon={<PlusOutlined />}
                        className={`${PF}__filters-list__item__button`}
                      />
                    </Tooltip>
                  </Dropdown>
                )}
              </div>
            );
          })}
        </div>
        <div className={`${PF}__buttons`}>
          <Button
            htmlType="reset"
            onClick={onResetFilters}
            className={`${PF}__buttons__item`}
          >
            <CloseCircleOutlined />
            Сброс
          </Button>
          <Button
            type="primary"
            onClick={onSearch}
            className={`${PF}__buttons__item`}
          >
            Показать
          </Button>
        </div>
      </div>
    </div>
  );
};
